import FastForward from './FastForward'

export default FastForward
// eslint-disable-next-line import/export
export * from './FastForward'
